<template>
    <div class="wout-login">
        <div class="center">
            <div>
                <img src="@/assets/img/boaviagem.svg" 
                    width="auto" height="130" alt="Boa Viagem!" crossorigin />
            </div>
            <span class="boaviagem">Tenha uma ótima viagem e até breve!</span>
        </div>
    </div>
</template>
<script>

export default {
    data: () => {
        return {
            
        }
    }
}
</script>

<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
}
.boaviagem {
    font-weight: normal;
    color: white!important;
    padding: 5px;
    width: 60vw;
    text-align: center;
}
</style>